import { OnInit } from '@angular/core'
import { Component } from '@angular/core'
import { faCircleExclamation, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { NotifyIcon } from './notify-icon'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './notify.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
    imports: [FaIconComponent],
})
export class NotifyComponent implements OnInit {
    faIcon = faCircleInfo
    icon!: NotifyIcon
    constructor(private _activeModal: NgbActiveModal) {}

    ngOnInit(): void {
        switch (this.icon) {
            case NotifyIcon.error:
                this.faIcon = faTriangleExclamation
                break
            case NotifyIcon.warning:
                this.faIcon = faCircleExclamation
                break
            case NotifyIcon.information:
                this.faIcon = faCircleInfo
                break
            default:
        }
    }

    public title!: string
    public message!: string

    public ok(): void {
        this._activeModal.close()
    }
}
